/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { Button, ChevronLeftIcon, FlexColumn, Icon, Text } from '@/shared/ui';
import { useTranslation } from 'react-i18next';

interface MockPaymentConfirmationProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const MockPaymentConfirmation: React.FC<MockPaymentConfirmationProps> = ({
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('@pages/onboarding');

  return (
    <FlexColumn className="items-center" style={{ paddingBlock: 'var(--space-16)', gap: 'var(--space-6)' }}>
      <div
        style={{
          border: '2px dashed var(--border-default)',
          borderRadius: 'var(--radius-md)',
          padding: 'var(--space-8)',
          maxWidth: 420,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <div
          className="text-xs font-bold"
          style={{
            display: 'inline-block',
            background: 'var(--surface-secondary)',
            color: 'var(--text-secondary)',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            padding: 'var(--space-1) var(--space-2-5)',
            borderRadius: 'var(--radius-sm)',
            marginBottom: 'var(--space-4)',
          }}
        >
          {t('payment.mockBadge')}
        </div>

        <Text
          className="text-base font-semibold"
          style={{
            color: 'var(--text-primary)',
            marginBottom: 'var(--space-2)',
          }}
        >
          {t('payment.mockTitle')}
        </Text>

        <Text
          className="text-sm"
          style={{
            color: 'var(--text-secondary)',
            lineHeight: 1.5,
          }}
        >
          {t('payment.mockDescription')}
        </Text>
      </div>

      <div className="flex flex-col w-full" style={{ gap: 'var(--space-3)', maxWidth: 280 }}>
        <Button onClick={onConfirm} className="w-full">
          {t('payment.mockConfirm')}
        </Button>
        <Button variant="ghost" onClick={onCancel} className="w-full" style={{ gap: 'var(--space-2)' }}>
          <Icon as={ChevronLeftIcon} style={{ height: 'var(--space-4)', width: 'var(--space-4)' }} />
          {t('payment.back')}
        </Button>
      </div>
    </FlexColumn>
  );
};

export default MockPaymentConfirmation;
